// Same rate selection for the legacy and composition inspectors.
// Decode recognizable Windows-1252/UTF-8 mojibake for labels only.
const windows1252 = '\u20ac\u0081\u201a\u0192\u201e\u2026\u2020\u2021\u02c6\u2030\u0160\u2039\u0152\u008d\u017d\u008f\u0090\u2018\u2019\u201c\u201d\u2022\u2013\u2014\u02dc\u2122\u0161\u203a\u0153\u009d\u017e\u0178';
const encodedSequence = new RegExp('[\\u00c2-\\u00f4][\\u0080-\\u00bf' + windows1252 + ']{1,3}', 'g');
export const laborProfileLabel = value => {
  let text = String(value ?? '');
  for (let pass = 0; pass < 2; pass++) {
    const next = text.replace(encodedSequence, sequence => {
      try { return decodeURIComponent([...sequence].map(char => {
        const index = windows1252.indexOf(char), byte = index < 0 ? char.charCodeAt(0) : index + 128;
        return '%' + byte.toString(16).padStart(2, '0');
      }).join('')); } catch { return sequence; }
    });
    if (next === text) break;
    text = next;
  }
  return text;
};

export const profileWithCurrentRate = (profile, versionParameters = [], today = new Date().toISOString().slice(0, 10)) => {
  if (!profile) return null;
  const rates = [...(profile.rates || [])].sort((a, b) => String(b.validFrom || '').localeCompare(String(a.validFrom || '')));
  const referenceRate = rates.find(rate => (!rate.validFrom || rate.validFrom <= today) && (!rate.validTo || rate.validTo >= today)) || rates[0] || null;
  const parameter = versionParameters.find(item => item.parameterCode === `laborRate.${profile.code}`);
  const cost = parameter?.valueNumber ?? referenceRate?.costHourlyRate;
  const currentRate = cost === undefined || cost === null ? referenceRate
    : { ...(referenceRate || {}), costHourlyRate: cost, sourceReference: parameter?.sourceReference || null };
  return { ...profile, currentRate, referenceRate };
};
